import type { RecommendationAddButtonProps } from "./recommendation-add-button.type";

import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

import { useRecommendationCreate } from "@/entities/recommendation";

const RecommendationAddButton = ({
  interventionId,
  observationId,
  ...buttonProps
}: RecommendationAddButtonProps) => {
  const { t } = useTranslation();
  const { isPending, createRecommendation } =
    useRecommendationCreate(interventionId);

  if (!interventionId || !observationId) return null;

  return (
    <Button
      {...buttonProps}
      loading={isPending}
      onClick={() => createRecommendation(observationId)}
      icon={<PlusOutlined />}
      title={t("recommendation:add.title")}
    >
      {t("recommendation:add.label")}
    </Button>
  );
};

export default RecommendationAddButton;
